// Import the generic hook
import useEntity from "../generic/useEntity.jsx";

// API
import { getService } from "../../api/services.jsx";

// Redux actions
import { setSelectedService, clearSelectedService } from "../../redux/slices/clientBoardSlice";

/**
 * Custom hook for fetching service details
 * Wrapper around generic useEntity hook for backward compatibility
 * @param {string} serviceId - ID of the service to fetch
 * @param {boolean} enabled - Whether the fetch should be enabled
 * @returns {Object} Object containing service from store, loading state, error and refetch function
 */
const useService = (serviceId, enabled = true) => {
  const config = {
    fetchFn: getService,
    selectFn: (state) => state.clientBoard.selectedService,
    setActionFn: setSelectedService,
    clearActionFn: clearSelectedService,
    entityName: "service"
  };

  const result = useEntity(serviceId, enabled, config);

  return {
    service: result.service,
    isLoading: result.isLoading,
    error: result.error,
    refetch: result.refetch
  };
};

export default useService;
